import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { SettingsPage } from "@/features/settings/settings-page";
import { optionalEnum } from "@/lib/list-state";

export const Route = createFileRoute("/_authenticated/settings/")({
  validateSearch: z.object({ tab: optionalEnum(["profile", "contract", "about"] as const) }),
  head: () => ({ meta: [{ title: "Settings · Rogue Admin" }] }),
  component: SettingsPage,
});
